import styled from '@emotion/styled';
import { motion } from 'framer-motion';

export const Wrapper = styled(motion.div)`
  background: #0f4f6d;
  white-space: nowrap;
  border-right: 1px solid rgba(255,255,255,0.2);
  height: 100vh;
  color: #ede5e5;
  display: flex;
  flex-direction: column;
  max-width: 250px;
  z-index: 1000;
  
  @media (max-width: 768px) {
    position: absolute;
    left: 0px;
  }
 
`;


export const WrapperGrup = styled(motion.div)`
  background: linear-gradient( #7788994b, #f0f2f52d),linear-gradient( #77889930, #f0f2f52d),linear-gradient( #77889930, #f0f2f52d);
  backdrop-filter: blur(5px);
  overflow: hidden;
  white-space: nowrap;
  height: 100vh;
  box-shadow: 1px 3px 5px rgba(100,100,100,.2);
  color: #0f4f6d;
  display: flex;
  flex-direction: column;
  position: fixed;
  max-width: 250px;
  top: 0;
  left: 250px;

`